import { ConnectStores } from "lib/core/store"
import Analytics from "./Analytics"

const limitString = function (str, limit) {
  if (!_.isString(str)) {
    return null
  }
  if (str.length > limit) {
    return `${str.substring(0, limit)}...`
  } else {
    return `${str}`
  }
}

const mapStateToProps = function (state, ownProps) {
  let analytics, item
  const { pathItemSourceId } = ownProps.match.params
  const { items, path } = state.pathStore.state
  const { offering } = state.resourceStore.state
  const { path_analytics } = state.pathAnalyticsStore.state
  const { getAnalyticsForItem } = state.pathAnalyticsStore.request
  const { findItem, getGroupStats, getPathStats } = state.pathStore.request
  const { modal_launched_from_url } = state.navigationStore.state

  if (pathItemSourceId && items) {
    item = __guard__(findItem(pathItemSourceId), (x) => x.serialize())
    analytics = getAnalyticsForItem(pathItemSourceId)
  } else {
    analytics = path_analytics
  }

  const item_name = limitString(item != null ? item.name : undefined, 20)

  const isLoading = !offering || !analytics

  const point_total = item
    ? item.item_type === "A"
      ? item.userpoints_value
      : getGroupStats(item.id).point_total
    : getPathStats().point_total

  const display_type = item
    ? item.item_type === "G"
      ? "lesson"
      : "step"
    : "path"

  return _.assign(
    {},
    {
      item_name,
      analytics,
      point_total,
      display_type,
      modal_launched_from_url,
      isLoading,
      path,
      offering
    },
    ownProps
  )
}

const stores = [
  { store: "navigation", watch: ["modal_launched_from_url"] },
  { store: "resource", watch: ["offering"] },
  { store: "path", watch: ["items"] },
  { store: "pathAnalytics", watch: ["path_analytics", "item_analytics"] }
]

export default ConnectStores(Analytics, stores, {}, mapStateToProps)

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
